var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 95c24.853 0 45-20.147 45-45 0-24.854-20.148-45-45-45S15 25.147 15 50c0 24.854 20.147 45 45 45z",
    fill: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse",
    x: -5,
    y: 5,
    width: 110,
    height: 90
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 95c24.853 0 45-20.147 45-45 0-24.854-20.148-45-45-45C-14.5 5-3 25.146-3 50c0 24.853-15.5 45 63 45z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.734,
    y: 21.906,
    width: 100,
    height: 56,
    rx: 4,
    fill: "#fff",
    filter: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 50c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11-11-4.925-11-11zm11-9c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z",
    fill: "#108060"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.13 47.957H19.87v-2h18.26v2zm0 6.088H19.87v-2h18.26v2z",
    fill: "#108060"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.744 39.428l.82.573.82.575-.004.005-.02.028c-.018.028-.047.07-.085.13-.075.118-.186.296-.32.53-.268.466-.63 1.15-.992 2.004-.727 1.714-1.442 4.078-1.442 6.73 0 2.65.717 5.014 1.444 6.728.362.854.724 1.538.992 2.005.134.233.245.41.32.53.038.058.067.1.085.13l.02.028.004.005-.82.573-.82.575v-.002l-.003-.005-.01-.013-.03-.046-.11-.167c-.09-.142-.216-.347-.37-.61-.3-.525-.7-1.282-1.097-2.22-.795-1.874-1.6-4.51-1.6-7.51 0-3.002.805-5.638 1.6-7.51.398-.94.797-1.697 1.1-2.222.15-.262.278-.467.37-.61.045-.07.08-.126.107-.165l.03-.046.01-.014.003-.005z",
    fill: "#108060"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.05 40.574l.82-.573.82-.57.004.006.01.013.03.045c.026.04.063.094.108.165.09.142.22.347.37.61.302.525.7 1.28 1.1 2.22.794 1.874 1.6 4.51 1.6 7.51 0 3.002-.806 5.638-1.6 7.51-.4.94-.798 1.697-1.1 2.222-.15.263-.28.468-.37.61-.045.072-.082.127-.108.166l-.03.046-.01.013-.003.005c0 .002 0 .002-.82-.57l-.82-.574.004-.005.02-.03c.02-.027.047-.07.085-.13.074-.117.185-.295.32-.528.27-.467.63-1.15.99-2.005.728-1.714 1.444-4.078 1.444-6.73 0-2.65-.716-5.014-1.442-6.728-.362-.854-.723-1.538-.992-2.005-.134-.233-.245-.41-.32-.53l-.085-.13-.02-.028-.003-.007zm0 0z",
    fill: "#108060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.733 56.46h2.99l2.216-8.5 2.03 8.5h3.01l3.572-13h-2.85l-2.24 8.974-2.147-8.973H54.82l-2.313 8.975-2.124-8.973h-3.13l3.48 13zm18.352 0h2.988l2.217-8.5 2.03 8.5h3.012l3.572-13h-2.85l-2.24 8.974-2.147-8.973H73.17l-2.31 8.975-2.126-8.973h-3.127l3.478 13zm18.352 0h2.988l2.217-8.5 2.03 8.5h3.01l3.572-13h-2.847l-2.24 8.974-2.148-8.973h-2.5l-2.312 8.975-2.124-8.973H83.96l3.477 13z",
    fill: "#42474C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 5.734,
    y: 17.906,
    width: 110,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v100H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.bb60d0e390fd1a5f4c010c4eec2207e8.svg";
export { ForwardRef as ReactComponent };